// extracted by mini-css-extract-plugin
export default {"box":"style_box__afahM"};